import React, { FC } from "react";
import { SECOND } from "chat/imports/constants";
import { formatDuration } from "chat/utils/formatDuration";
import styles from "./common.scss";

export const MessageDuration: FC<{ duration: number }> = ({ duration }) => (
  <div className={styles.duration}>{formatDuration(duration * SECOND)}</div>
);
